import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { withNamespaces } from 'react-i18next';

export const MetaComponent = withNamespaces()(
  ({
    description,
    appVersion,
    title,
    url,
    image,
    facebookAppId,
    itunesAppId,
    itunesUrl,
    googlePlayUrl,
    siteId,
    t,
  }) => {
    const metaDescription = description || t('meta_description_generic');
    return (
      <Helmet>
        <title>Pluto TV</title>
        <meta charSet="utf-8" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="description" content={metaDescription} />
        <meta name="appVersion" content={appVersion} />
        <meta property="og:title" content={title} />
        <meta property="og:site_name" content="Pluto TV" />
        <meta property="og:url" content={url} />
        <meta property="og:description" content={metaDescription} />
        <meta property="fb:app_id" content={facebookAppId} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={image} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1500" />
        <meta property="og:image:height" content="1500" />
        <meta name="twitter:site" content="@PlutoTV" />
        <meta name="twitter:site:id" content={siteId} />
        <meta name="twitter:domain" content="pluto.tv" />
        <meta name="twitter:app:name:iphone" content="Pluto TV: TV for the Internet" />
        <meta name="twitter:app:id:iphone" content={itunesAppId} />
        <meta name="twitter:app:url:iphone" content={itunesUrl} />
        <meta name="twitter:app:name:ipad" content="Pluto TV: TV for the Internet" />
        <meta name="twitter:app:id:ipad" content={itunesAppId} />
        <meta name="twitter:app:url:ipad" content="iTunesUri" />
        <meta name="twitter:app:name:googleplay" content="Pluto TV: TV for the Internet" />
        <meta name="twitter:app:id:googleplay" content="tv.pluto.android" />
        <meta name="twitter:app:url:googleplay" content={googlePlayUrl} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="robots" content="." />
        <meta
          name="apple-itunes-app"
          content={`app-id=${itunesAppId}, app-argument=${itunesUrl}`}
        />
      </Helmet>
    );
  },
);
MetaComponent.propTypes = {
  description: PropTypes.string,
  appVersion: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  facebookAppId: PropTypes.string,
  siteId: PropTypes.string,
  itunesAppId: PropTypes.string,
  itunesUrl: PropTypes.string,
  googlePlayUrl: PropTypes.string,
};
MetaComponent.defaultProps = {
  description: '',
  appVersion: process.env.APP_VERSION,
  facebookAppId: process.env.FACEBOOK_APP_ID,
  googlePlayUrl: 'https://play.google.com/store/apps/details?id=tv.pluto.android&hl=en_US',
  image: 'http://pluto.tv/assets/images/og-logo-v5.png',
  itunesAppId: '751712884',
  itunesUrl: 'https://apps.apple.com/us/app/pluto-tv-live-tv-and-movies/id751712884',
  siteId: '2295012080',
  title: 'Pluto TV',
  url: '',
};
